import api from './../../api';
import { push } from 'connected-react-router';
import { store as storeNotification } from 'react-notifications-component';
import { socket } from './../store/socket';

const notificationConfig = {
  container: 'top-center',
  animationIn: ['animated', 'fadeIn'],
  animationOut: ['animated', 'fadeOut'],
  dismiss: {
    duration: 1500,
    showIcon: true
  }
};

export const departmentsStartRequest = () => {
  return {
    type: 'DEPARTMENTS_START_REQUEST'
  };
};

export const departmentsEndRequest = () => {
  return {
    type: 'DEPARTMENTS_END_REQUEST'
  };
};

export const getAllDepartmentsSuccess = ({ data }) => {
  return {
    type: 'DEPARTMENTS_GET_ALL_SUCCESS',
    payload: data
  };
};

export const getAllDepartmentsError = error => {
  return {
    type: 'DEPARTMENTS_GET_ALL_ERROR',
    payload: error
  };
};

export const addDepartmentsSuccess = ({ data }) => {
  return {
    type: 'DEPARTMENTS_ADD_SUCCESS',
    payload: data
  };
};

export const addDepartmentsError = error => {
  return {
    type: 'DEPARTMENTS_ADD_ERROR',
    payload: error
  };
};

export const editDepartmentsSuccess = ({ data }) => {
  return {
    type: 'DEPARTMENTS_EDIT_SUCCESS',
    payload: data
  };
};

export const editDepartmentsError = error => {
  return {
    type: 'DEPARTMENTS_EDIT_ERROR',
    payload: error
  };
};

export const removeDepartmentsSuccess = id => {
  return {
    type: 'DEPARTMENTS_REMOVE_SUCCESS',
    payload: id
  };
};

export const removeDepartmentsError = error => {
  return {
    type: 'DEPARTMENTS_REMOVE_ERROR',
    payload: error
  };
};

export const departmentsModifyStore = ({ data }) => {
  return {
    type: 'DEPARTMENTS_MODIFY_STORE',
    payload: data
  };
};

export const addDepartments = (data, formReset, submitBtn) => {
  return async dispatch => {
    try {
      submitBtn.disabled = true;
      dispatch(departmentsStartRequest());
      const response = await api().post('/api/departments', data);
      dispatch(addDepartmentsSuccess(response));
      socket.emit('requestChangeStore', {
        token: localStorage.getItem('token') || '',
        type: 'ADD',
        module: 'departments',
        data: [response.data]
      });
      formReset();
    } catch (err) {
      dispatch(addDepartmentsError(err));
    } finally {
      document
        .getElementsByClassName('page-content')[0]
        .scrollTo({ top: 0, left: 0, behavior: 'smooth' });
      setTimeout(() => {
        dispatch(departmentsEndRequest());
        submitBtn.disabled = false;
      }, 1800);
    }
  };
};

export const getAllDepartments = (params = {}) => {
  return async dispatch => {
    try {
      dispatch(departmentsStartRequest());
      const response = await api().get('/api/departments', { params });
      dispatch(getAllDepartmentsSuccess(response));
    } catch (err) {
      dispatch(getAllDepartmentsError(err));
    } finally {
      dispatch(departmentsEndRequest());
    }
  };
};

export const editDepartments = (data, submitBtn = {}, handleModalClose) => {
  return async dispatch => {
    const defaultMsg = button => {
      return new Promise(resolve => {
        document
          .getElementsByClassName('page-content')[0]
          .scrollTo({ top: 0, left: 0, behavior: 'smooth' });
        setTimeout(() => {
          dispatch(departmentsEndRequest());
          button.disabled = false;
          resolve(true);
        }, 1800);
      });
    };

    try {
      submitBtn.disabled = true;
      dispatch(departmentsStartRequest());
      const id = data._id;
      const response = await api().put('/api/departments/' + id, data);
      dispatch(editDepartmentsSuccess(response));
      socket.emit('requestChangeStore', {
        token: localStorage.getItem('token') || '',
        type: 'EDIT',
        module: 'departments',
        data: [response.data]
      });
      await defaultMsg(submitBtn);
      if (handleModalClose) {
        handleModalClose();
      } else {
        dispatch(push('/departments'));
      }
    } catch (err) {
      dispatch(editDepartmentsError(err));
      await defaultMsg(submitBtn);
    }
  };
};

export const removeDepartments = id => {
  return async dispatch => {
    try {
      dispatch(departmentsStartRequest());
      await api().delete('/api/departments/' + id);
      dispatch(removeDepartmentsSuccess(id));
      socket.emit('requestChangeStore', {
        token: localStorage.getItem('token') || '',
        type: 'REMOVE',
        module: 'departments',
        data: id
      });
      setTimeout(() => {
        storeNotification.addNotification({
          ...notificationConfig,
          message: 'Departamento removido com sucesso.',
          type: 'success'
        });
      }, 300);
    } catch (err) {
      dispatch(removeDepartmentsError(err));
      setTimeout(() => {
        storeNotification.addNotification({
          ...notificationConfig,
          message: 'Falha ao remover departamento.',
          type: 'danger'
        });
      }, 300);
    } finally {
      document
        .getElementsByClassName('page-content')[0]
        .scrollTo({ top: 0, left: 0, behavior: 'smooth' });
      dispatch(departmentsEndRequest());
    }
  };
};

export const restoreDepartments = data => {
  return async dispatch => {
    try {
      dispatch(departmentsStartRequest());
      const id = data._id;
      const response = await api().put('/api/departments/' + id, data);
      dispatch(editDepartmentsSuccess(response));
      socket.emit('requestChangeStore', {
        token: localStorage.getItem('token') || '',
        type: 'RESTORE',
        module: 'departments',
        data: [response.data]
      });
      setTimeout(() => {
        storeNotification.addNotification({
          ...notificationConfig,
          message: 'Departamento restaurado com sucesso.',
          type: 'success'
        });
      }, 300);
    } catch (err) {
      dispatch(editDepartmentsError(err));
      setTimeout(() => {
        storeNotification.addNotification({
          ...notificationConfig,
          message: 'Falha ao restaurar departamento.',
          type: 'danger'
        });
      }, 300);
    } finally {
      document
        .getElementsByClassName('page-content')[0]
        .scrollTo({ top: 0, left: 0, behavior: 'smooth' });
      dispatch(departmentsEndRequest());
    }
  };
};
